export enum RoleModalType {
	Create = 'create',
	Update = 'update',
	User = 'user'
}
